import { ApiResponse, GlobalStore } from "@roc/feature-app-core";
import { flow, makeObservable, observable } from "mobx";
import { PayoffService } from "../services/payoffService";

export class InterestAllocationStore {
  globalStore: GlobalStore;
  service: PayoffService;
  interestAllocatioDataRows: any;


  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.service = new PayoffService();
    makeObservable(this, {
      interestAllocatioDataRows: observable,
      getDefaultInterestAllocation: flow,
      getForeclosureInterestAllocation: flow,
      saveForeclosureInterestAllocation: flow,
      saveDefaultInterestAllocation: flow,
    });
  };

  *getForeclosureInterestAllocation(loanId: number) {
    try {
      const response: ApiResponse = yield this.service.getForeclosureInterestAllocation(loanId);
      this.interestAllocatioDataRows = response?.data?.data;
    }
    catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while getting foreclosure interest allocation data.',
      });
    }
  };

  *getDefaultInterestAllocation(loanId: number) {
    try {
      const response: ApiResponse = yield this.service.getDefaultInterestAllocation(loanId);
      const interestAllocatioData = response?.data?.data;
      this.interestAllocatioDataRows = this.getDefaultIterestAllocationRows(interestAllocatioData);
    }
    catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while getting default interest allocation data.',
      });
    }
  };

  *saveForeclosureInterestAllocation(loanId) {
    try {
      yield this.service.saveForeclosureInterestAllocation(loanId, this.interestAllocatioDataRows);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Foreclosure interest allocation data saved successfully.',
      });
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while saving foreclosure interest allocation data.',
      });
    }
  }

  *saveDefaultInterestAllocation(loanId) {
    try {
      const defaultInterestAllocation = this.getDefaultIterestAllocationFromRows(loanId);
      yield this.service.saveDefaultInterestAllocation(defaultInterestAllocation);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Interest allocation data saved successfully.',
      });
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while saving foreclosure allocation data.',
      });
    }
  }

  getDefaultIterestAllocationFromRows(loanId) {
    return {
      loanId,
      interestNoteRate: this.interestAllocatioDataRows[0].totalInterest,
      interestDefaultRate: this.interestAllocatioDataRows[1].totalInterest,
      loanServicerNoteRate: this.interestAllocatioDataRows[0].loanServicer,
      loanServicerDefaultRate: this.interestAllocatioDataRows[1].loanServicer,
      tpoNoteRate: this.interestAllocatioDataRows[0].tpo,
      tpoDefaultRate: this.interestAllocatioDataRows[1].tpo,
      investorNoteRate: this.interestAllocatioDataRows[0].investor,
      investorDefaultRate: this.interestAllocatioDataRows[1].investor,
      funderNoteRate: this.interestAllocatioDataRows[0].funder,
      funderDefaultRate: this.interestAllocatioDataRows[1].funder,
      totalInterest: this.interestAllocatioDataRows[2].totalInterest,
      totalServicerInterest: this.interestAllocatioDataRows[2].loanServicer,
      totalTpoInterest: this.interestAllocatioDataRows[2].tpo,
      totalInvestorInterest: this.interestAllocatioDataRows[2].investor,
      totalFunderInterest: this.interestAllocatioDataRows[2].funder,
    }
  }


  getDefaultIterestAllocationRows(interestAllocation: any) {
    return [
      {
        description: 'Note Rate',
        totalInterest: interestAllocation.interestNoteRate,
        loanServicer: interestAllocation.loanServicerNoteRate,
        tpo: interestAllocation.tpoNoteRate,
        investor: interestAllocation.investorNoteRate,
        funder: interestAllocation.funderNoteRate,
      },
      {
        description: 'Default Rate',
        totalInterest: interestAllocation.interestDefaultRate,
        loanServicer: interestAllocation.loanServicerDefaultRate,
        tpo: interestAllocation.tpoDefaultRate,
        investor: interestAllocation.investorDefaultRate,
        funder: interestAllocation.funderDefaultRate,
      },
      {
        description: 'Total',
        totalInterest: interestAllocation.totalInterest,
        loanServicer: interestAllocation.totalServicerInterest,
        tpo: interestAllocation.totalTpoInterest,
        investor: interestAllocation.totalInvestorInterest,
        funder: interestAllocation.totalFunderInterest,
      }
    ]
  }

}